document.addEventListener("DOMContentLoaded", function () {
  const cardSlider = document.querySelector(".cardSlider");

  if (cardSlider) {
    const cardSliderGlide = document.querySelector(".cardSlider__glide");
    const cardSliderBtns = document.querySelectorAll(".cardSlider-arrow");
    const progressBar = document.querySelector(".cardSlider__progress-bar");
    let totalSlides = 0;

    if (cardSliderGlide) {

      const csGlide = new Glide(cardSliderGlide, {
        type: 'slider',
        gap: 20,
        perView: 4,
        rewind: false,
        startAt: 0,
        keyboard: false,
        breakpoints: {
          1366: {
            perView: 2.5
          },
          1200: {
            perView: 2
          },
          576: {
            perView: 1
          }
        }
      });

      csGlide.on(['mount.after', 'run'], () => {
        totalSlides = countSlides(); // Count slides after mount
        updateProgressBar(csGlide.index, totalSlides);
        updateButtonState(csGlide.index, totalSlides); // Update button state
      });

      /*
      * Custom controls
      */

      cardSliderBtns.forEach(button => {
        button.addEventListener("click", () => {
          if (!button.classList.contains("disabled")) {
            csGlide.go(button.classList.contains("cardSlider-prev") ? '<' : '>');
          }
        });
        button.addEventListener("keydown", event => {
          if (event.key === "Enter" && !button.classList.contains("disabled")) {
            csGlide.go(button.classList.contains("cardSlider-prev") ? '<' : '>');
          }
        });
      });

      /*
      * Progress bar
      */

      csGlide.on('run', () => {
        updateProgressBar(csGlide.index, totalSlides);
        updateButtonState(csGlide.index, totalSlides);
      });

      function countSlides() {
        const activeSlides = cardSliderGlide.querySelectorAll('.glide__slide:not(.glide__slide--clone)');
        return activeSlides.length;
      }

      function updateProgressBar(index, totalSlides) {
        if (totalSlides > 0) {
          const maxIndex = totalSlides - csGlide.settings.perView;
          const progress = (index / maxIndex) * 100;
          progressBar.style.width = `${progress}%`;

          const prevButton = document.querySelector(".cardSlider-prev");
          const nextButton = document.querySelector(".cardSlider-next");

          if (index === 0) {
            prevButton.classList.add("disabled");
          } else {
            prevButton.classList.remove("disabled");
          }

          if (index === maxIndex) {
            nextButton.classList.add("disabled");
          } else {
            nextButton.classList.remove("disabled");
          }
        }
      }


      function updateButtonState(index, totalSlides) {
        const prevButton = document.querySelector(".cardSlider-prev");
        const nextButton = document.querySelector(".cardSlider-next");
      }

      /*
      * Init glide
      */

      csGlide.mount();

    }
  }
});
